export enum EPackageStatus {
  Active = 1,
  Inactive = 2,
}
